import { call, put } from 'redux-saga/effects';
import { setNewReleaseSeenFailure, setNewReleaseSeenSuccess } from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { setNewReleaseSeen } from '../api';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { SetNewReleaseSeenRequestAction } from '../types';
import { MessageStatus } from 'store/api/enums';
import { fetchMeRequest, logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* setNewReleaseSeenSaga(action: SetNewReleaseSeenRequestAction) {
  try {
    let err: ApiError | null;
    const { accountUuid } = action.payload;
    const response: ApiResponse = yield call(setNewReleaseSeen, accountUuid);

    err = checkResponse(response?.responseMessage);
    if (err && response.responseMessage.status === MessageStatus.UNAUTHORIZED) {
      yield put(logoutRequest());
      return;
    }
    if (err) throw err;

    yield put(setNewReleaseSeenSuccess());
    // Refresh user details to update isNewReleaseSeen
    yield put(fetchMeRequest());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(setNewReleaseSeenFailure());
  }
}

